import Immutable from 'immutable'
import moment from 'moment'

import Notification from './SignupStateTransitionNotification'

export const SignupStateTransitionRecord = Immutable.Record({
  creator: null,
  creatorIp: '',
  dateAdded: null,
  dateUpdated: null,
  fromState: null,
  id: null,
  notes: '',
  notifications: Immutable.Set(),
  requestId: '',
  toState: null,
  userAgent: '',
  // These properties come from specific implementations of StateTransition
  // and are only present for transition types that define these properties.
  additionalCharges: Immutable.Map(),
  agreeDate: null,
  attendanceRequired: false,
  clientServiceId: null,
  contractId: null,
  installDate: null,
  installTime: null,
  mspAgreeDate: null,
  payment: null,
  serviceIds: Immutable.Map(), // A map of identifiers for the service (NTDID, UNID, etc)
  supplierOrderId: null,
}, 'SignupStateTransition')

export default function createSignupStateTransition({
  attendanceRequired = false,
  agreeDate,
  creator,
  dateAdded,
  dateUpdated,
  installDate,
  mspAgreeDate,
  notifications = [],
  payment,
  serviceIds = [],
  ...signupStateTransition
}) {
  return new SignupStateTransitionRecord({
    agreeDate: agreeDate ? moment(agreeDate) : null,
    attendanceRequired,
    creator: creator ? creator.id : null,
    dateAdded: dateAdded ? moment(dateAdded) : null,
    dateUpdated: dateUpdated ? moment(dateUpdated) : null,
    installDate: installDate ? moment(installDate) : null,
    mspAgreeDate: mspAgreeDate ? moment(mspAgreeDate) : null,
    notifications: notifications.map(n => new Notification(n)),
    payment: payment ? payment.reference : null,
    serviceIds: Immutable.Map(serviceIds),
    ...signupStateTransition,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/SignupStateTransition.js